import {
  countries
} from '../helpers/countries';
import {
  applicantFields,
  studentNumberFields,
  provinceOfResidenceFields
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'msgascnnonmed';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [{
      key_path: ['application', 'additional_data', 'membership_number'],
      as: 'Association Membership Number',
      is_static_by_default: true
    }],
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'dependent',
          text: 'Dependent Child'
        },
        {
          value: 'travelling companion',
          text: 'Travelling Companion'
        },
        {
          value: 'spouse',
          text: 'Spouse'
        }
      ]),
      ...studentNumberFields('*')
    ],
    coverage_fields: [{
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries(),
        is_static_by_default: true
      },
      ...provinceOfResidenceFields(),
      {
        key_path: ['application', 'additional_data', 'trip_cost'],
        as: 'Trip Cost',
        format: 'currency'
      },
      {
        key_path: ['application', 'additional_data', 'cancel_delux'],
        as: 'Trip Cancellation - Deluxe Option',
        type: 'dropdown',
        options: [
          {value: 'no', text: 'No'},
          {value: 'yes', text: 'Yes'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'trip_booked_date'],
        as: 'Trip Booking Date',
        format: 'date'
      },
      {
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: countries(true),
        show_if: [{
          key_path: ['application', 'additional_data', 'country_of_origin'],
          value: 'CA'
        }],
      },
      {
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: countries(),
        is_static_by_default: true,
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'country_of_origin'],
          value: 'CA'
        }],
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/msgascnnonmed.js